enum DisplayNames {
  Accordion = 'AccordionExperimental',
  AccordionItem = 'AccordionItemExperimental',
  AccordionButton = 'AccordionButtonExperimental',
  AccordionIcon = 'AccordionIconExperimental',
  AccordionPanel = 'AccordionPanelExperimental'
}

export default DisplayNames;
